import React, { useMemo, useState } from 'react';
import { notificar } from '../../components/SistemaToast/notificar';

// Formulario de una tarjeta de la alerta "HC sin asignar": PI sugerida, OC, HC y botón Asignar.
// Las PI sugeridas son las del mismo destino del booking, con saldo sin booking y OC vinculada.
const AsignarHc = ({ item, pis, onAsignar, onFicha }) => {
    const [idPi, setIdPi] = useState('');
    const [idOc, setIdOc] = useState('');
    const [idProducto, setIdProducto] = useState('');
    const [hcTexto, setHcTexto] = useState(null); // null = usar el valor sugerido
    const [guardando, setGuardando] = useState(false);

    // Mismo destino que el booking; primero las PI de los clientes que ya tiene el booking, luego por ETD
    const opciones = useMemo(() => (
        pis
            .filter((p) => Number(p.id_puerto) === Number(item.id_puerto_destino))
            .sort((a, b) => {
                const clienteA = item.ids_cliente.includes(a.id_cliente) ? 0 : 1;
                const clienteB = item.ids_cliente.includes(b.id_cliente) ? 0 : 1;
                return clienteA - clienteB || (a.etd_objetivo || '').localeCompare(b.etd_objetivo || '');
            })
    ), [pis, item.id_puerto_destino, item.ids_cliente]);

    const pi = opciones.find((p) => String(p.id_proforma) === idPi) || opciones[0];
    const oc = pi ? (pi.ocs.find((o) => String(o.id_ordencompra) === idOc) || pi.ocs[0]) : null;
    const productos = oc ? oc.productos : [];
    const producto = productos.find((p) => String(p.id_producto) === idProducto) || productos[0];
    const maximo = pi ? Math.min(item.libres, pi.saldo) : 0;
    const hcValor = hcTexto === null ? String(maximo) : hcTexto;

    const cambiarPi = (valor) => { setIdPi(valor); setIdOc(''); setIdProducto(''); setHcTexto(null); };
    const cambiarOc = (valor) => { setIdOc(valor); setIdProducto(''); };

    const asignar = async () => {
        const cantidad = Number(hcValor);
        if (!Number.isInteger(cantidad) || cantidad < 1) {
            notificar.aviso('Ingresa los HC a asignar (un entero mayor a cero).');
            return;
        }
        if (cantidad > maximo) {
            notificar.aviso(`Solo puedes asignar hasta ${maximo} HC: el menor entre los libres del booking (${item.libres}) y el saldo de la PI (${pi.saldo}).`);
            return;
        }
        if (!producto) {
            notificar.aviso('No se pudo determinar el producto de la PI y la OC. Asigna los HC desde la ficha.');
            return;
        }
        setGuardando(true);
        try {
            await onAsignar(item.id_solicitud, {
                id_proforma: pi.id_proforma,
                id_ordencompra: oc.id_ordencompra,
                id_producto: producto.id_producto,
                cantidad_hc: cantidad,
            });
            notificar.exito(`${cantidad} HC asignados a ${pi.id_pi} en el booking ${item.nro_booking || `Sin N° (${item.ffw || '—'})`}.`);
            setHcTexto(null);
        } catch (e) {
            notificar.error(e.message);
        } finally {
            setGuardando(false);
        }
    };

    return (
        <>
            {opciones.length === 0 ? (
                <div className="ap-sin-sugerencia">
                    No hay PI con saldo sin booking, OC vinculada y el mismo destino ({item.pod || '—'}). Puedes asignar desde la ficha.
                </div>
            ) : (
                <div className="ap-asignar">
                    <label className="ce-filtro">
                        PI sugerida (mismo destino)
                        <select value={pi.id_proforma} onChange={(e) => cambiarPi(e.target.value)}>
                            {opciones.map((p) => (
                                <option key={p.id_proforma} value={p.id_proforma}>
                                    {p.id_pi} · saldo {p.saldo} · {p.pod}
                                </option>
                            ))}
                        </select>
                    </label>
                    <label className="ce-filtro">
                        OC
                        <select value={oc.id_ordencompra} onChange={(e) => cambiarOc(e.target.value)}>
                            {pi.ocs.map((o) => (
                                <option key={o.id_ordencompra} value={o.id_ordencompra}>
                                    {o.id_oc} · {o.proveedor || '—'}
                                </option>
                            ))}
                        </select>
                    </label>
                    <label className="ce-filtro ap-asignar-hc">
                        HC
                        <input
                            type="number"
                            min="1"
                            max={maximo}
                            step="1"
                            value={hcValor}
                            onChange={(e) => setHcTexto(e.target.value)}
                        />
                    </label>
                    <button type="button" className="ui-btn ui-btn-primary" onClick={asignar} disabled={guardando}>
                        {guardando ? 'Asignando…' : 'Asignar'}
                    </button>
                    {productos.length > 1 && (
                        <label className="ce-filtro ap-asignar-producto">
                            Producto (la PI y la OC tienen más de uno)
                            <select value={producto.id_producto} onChange={(e) => setIdProducto(e.target.value)}>
                                {productos.map((p) => (
                                    <option key={p.id_producto} value={p.id_producto}>{p.nombre}</option>
                                ))}
                            </select>
                        </label>
                    )}
                </div>
            )}
            <div className="ap-enlaces">
                <button type="button" className="ce-accion" onClick={() => onFicha(item.id_solicitud)}>Abrir ficha</button>
            </div>
        </>
    );
};

export default AsignarHc;
